import {mapKeys, snakeCase} from 'lodash-es';
import type {AxiosRequestConfig} from 'axios';

import {spotheroPost} from 'api';
import type {
    EventTypeOption,
    GetEventTypeOptionsRequest,
} from 'api/events/events.types';
import {apiDateFormat} from 'utils/date-time';
import dayjs from 'utils/dayjs';
import {sendSentryException} from 'utils/error-handling';
import {camelizeKeys} from 'utils/format-strings';

/**
 * Format the response of the Event Types option s.
 */
const formatEventTypeOptionsResponse = (data: EventTypeOption[]) => {
    const formatedData = camelizeKeys(data);

    return formatedData;
};

/**
 * Format the request to get Event Types options.
 */
const formatEventTypeOptionsRequest = (data: GetEventTypeOptionsRequest) => {
    const formattedData = mapKeys(data, (value, key) => snakeCase(key));

    return {
        ...formattedData,
        // eslint-disable-next-line camelcase
        from_date: data.fromDate && dayjs(data.fromDate).format(apiDateFormat),
        // eslint-disable-next-line camelcase
        to_date: data.toDate && dayjs(data.toDate).format(apiDateFormat),
    };
};

/**
 * Gets a list of Event Types options for a given facility and date range.
 */
const getEventTypeOptions = async (
    params: GetEventTypeOptionsRequest,
    config: AxiosRequestConfig = {}
) => {
    try {
        const formattedRequest = formatEventTypeOptionsRequest(params);

        const response = await spotheroPost<EventTypeOption[]>(
            `events/event-type-options/`,
            formattedRequest,
            config,
            false
        );

        const formattedResponse = formatEventTypeOptionsResponse(
            response.data.data.results
        );

        return formattedResponse;
    } catch (error) {
        sendSentryException(error);

        throw error;
    }
};

export default getEventTypeOptions;
